(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ff-collection-filter-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ff-collection-filter-bar')) {
    (function () {
      function closeFfAvailabilityPanel() {
        const trigger = document.getElementById('filter-toggle');
        const panel = document.getElementById('subfilter-dropdown');
        if (!trigger || !panel) return;
        panel.classList.add('ff-collection-filter-bar__panel--hidden');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.querySelector('.ff-cfb-arrow')?.classList.remove('ff-cfb-arrow--open');
      }

      function closeFfSizePanel() {
        const trigger = document.getElementById('sort-toggle');
        const panel = document.getElementById('sort-dropdown');
        if (!trigger || !panel) return;
        panel.classList.add('ff-collection-filter-bar__panel--hidden');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.querySelector('.ff-cfb-arrow')?.classList.remove('ff-cfb-arrow--open');
      }

      function forwardFfClickToTarget(button) {
        document.getElementById(button.dataset.ffTargetOption)?.querySelector('[target="true"]')?.click();
      }

      function clearFfFilter(button) {
        document.querySelector('ff-filter-menu-drawer')?.removeAll(button.dataset.ffClearFilter);
      }

      function wireFfPanelOptions(panel, closePanel) {
        panel.querySelectorAll('button[data-ff-target-option]').forEach((button) => {
          button.addEventListener('click', () => { closePanel(); forwardFfClickToTarget(button); });
        });
        panel.querySelectorAll('button[data-ff-clear-filter]').forEach((button) => {
          button.addEventListener('click', () => { closePanel(); clearFfFilter(button); });
        });
      }

      function ffAvailabilityButtons(panel) {
        return Array.from(panel.querySelectorAll('.ff-cfb-availability-option[data-ff-target-option]'));
      }

      function applyFfAvailabilitySingle(button, panel) {
        ffAvailabilityButtons(panel).forEach((b) => {
          b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
        });

        const drawerOption = document.getElementById(button.dataset.ffTargetOption);
        const drawer = document.querySelector('ff-filter-menu-drawer');
        if (!drawerOption || !drawer) return;

        const key = drawerOption.option_key || drawerOption.getAttribute('option-key');
        if (!key) return;

        const isSeeAll = (button.dataset.ffTargetOption || '').endsWith('-all');

        drawerOption
          .closest('.ff-options-container')
          ?.querySelectorAll('ff-filter-option')
          .forEach((opt) => { opt.selected = opt === drawerOption; });

        drawer.setOption(
          key,
          isSeeAll ? [] : [drawerOption.option_value || drawerOption.getAttribute('option-value')],
          true
        );
      }

      function normalizeFfAvailabilityVisual(panel) {
        const buttons = ffAvailabilityButtons(panel);
        if (buttons.filter((b) => b.getAttribute('aria-pressed') === 'true').length === 1) return;
        const seeAll = buttons.find((b) => (b.dataset.ffTargetOption || '').endsWith('-all'));
        if (!seeAll) return;
        buttons.forEach((b) => b.setAttribute('aria-pressed', b === seeAll ? 'true' : 'false'));
      }

      function wireFfAvailabilityOptions(panel, closePanel) {
        panel.querySelectorAll('button[data-ff-target-option]').forEach((button) => {
          button.addEventListener('click', () => { closePanel(); applyFfAvailabilitySingle(button, panel); });
        });
        normalizeFfAvailabilityVisual(panel);
      }

      function openFfPanel(panel, trigger) {
        panel.classList.remove('ff-collection-filter-bar__panel--hidden');
        trigger.setAttribute('aria-expanded', 'true');
        trigger.querySelector('.ff-cfb-arrow')?.classList.add('ff-cfb-arrow--open');
      }

      let ffPanelWasOpen = false;
      document.addEventListener('click', (event) => {
        const availabilityTrigger = document.getElementById('filter-toggle');
        const availabilityPanel = document.getElementById('subfilter-dropdown');
        const sizeTrigger = document.getElementById('sort-toggle');
        const sizePanel = document.getElementById('sort-dropdown');

        if (!availabilityTrigger || !availabilityPanel) return;

        const clickedInsideBar =
          availabilityTrigger.contains(event.target) || availabilityPanel.contains(event.target) ||
          (sizeTrigger && sizePanel && (sizeTrigger.contains(event.target) || sizePanel.contains(event.target)));

        if (!clickedInsideBar) {
          let closedAnyPanel = false;
          if (!availabilityPanel.classList.contains('ff-collection-filter-bar__panel--hidden')) { closeFfAvailabilityPanel(); closedAnyPanel = true; }
          if (sizePanel && !sizePanel.classList.contains('ff-collection-filter-bar__panel--hidden')) { closeFfSizePanel(); closedAnyPanel = true; }
          if (closedAnyPanel) { ffPanelWasOpen = true; event.preventDefault(); event.stopPropagation(); return; }
        }
        if (ffPanelWasOpen) ffPanelWasOpen = false;
      });

      class FfCollectionFilterBar extends HTMLElement {
        connectedCallback() {
          const availabilityTrigger = this.querySelector('#filter-toggle');
          const availabilityPanel = this.querySelector('#subfilter-dropdown');
          const sizeTrigger = this.querySelector('#sort-toggle');
          const sizePanel = this.querySelector('#sort-dropdown');

          if (!availabilityTrigger || !availabilityPanel) return;

          this.querySelector('#filters-toggle')?.addEventListener('click', () => {
            document.querySelector('ff-filter-menu-drawer')?.show();
          });

          availabilityTrigger.addEventListener('click', () => {
            const isOpen = !availabilityPanel.classList.contains('ff-collection-filter-bar__panel--hidden');
            closeFfSizePanel();
            isOpen ? closeFfAvailabilityPanel() : openFfPanel(availabilityPanel, availabilityTrigger);
          });
          wireFfAvailabilityOptions(availabilityPanel, closeFfAvailabilityPanel);

          if (sizeTrigger && sizePanel) {
            sizeTrigger.addEventListener('click', () => {
              const isOpen = !sizePanel.classList.contains('ff-collection-filter-bar__panel--hidden');
              closeFfAvailabilityPanel();
              isOpen ? closeFfSizePanel() : openFfPanel(sizePanel, sizeTrigger);
            });
            wireFfPanelOptions(sizePanel, closeFfSizePanel);
          }

          if (this.dataset.ffEnableBloomreach === 'true') this.populateFromBloomreach();
        }

        populateFromBloomreach() {
          if (this.dataset.ffEnableBloomreach !== 'true') return;
          const drawer = document.querySelector('ff-filter-menu-drawer');
          if (!drawer) return;

          const availabilityLabels = (this.dataset.ffAvailabilityLabels || '').split(',');
          const sizeLabels = (this.dataset.ffSizeLabels || '').split(',');

          const buildOptions = (drawerContainer, panel, closePanel, optionClass) => {
            const scroll = panel.querySelector('.ff-collection-filter-bar__panel-scroll') || panel;
            scroll.innerHTML = '';
            let optionCount = 0;
            drawerContainer.querySelectorAll('ff-filter-option').forEach((option) => {
              const label = option.textContent.trim();
              if (!label) return;
              const isSelected = option.getAttribute('selected') === 'true';
              const isDisabled = option.getAttribute('disabled') === 'true';
              const button = document.createElement('button');
              button.type = 'button';
              button.className = `ff-cfb-option ${optionClass}`;
              if (isDisabled) button.classList.add('ff-cfb-option--disabled');
              button.setAttribute('aria-pressed', `${isSelected}`);
              button.dataset.ffTargetOption = option.id;
              if (isDisabled) button.disabled = true;
              button.textContent = label;
              scroll.appendChild(button);
              optionCount++;
            });
            if (optionClass === 'ff-cfb-availability-option') wireFfAvailabilityOptions(panel, closePanel);
            else wireFfPanelOptions(panel, closePanel);
            return optionCount;
          };

          const availabilitySlot = this.querySelector('#filter-toggle')?.closest('.ff-cfb-slot');
          const sizeSlot = this.querySelector('#sort-toggle')?.closest('.ff-cfb-slot');
          const sizeSeparator = sizeSlot?.nextElementSibling;

          const toggleSlot = (slot, hasContent, separator) => {
            if (slot) slot.style.display = hasContent ? '' : 'none';
            if (separator && separator.classList.contains('ff-cfb-sep')) separator.style.display = hasContent ? '' : 'none';
          };

          toggleSlot(availabilitySlot, false);
          toggleSlot(sizeSlot, false, sizeSeparator);

          drawer.querySelectorAll('[id^="ff-filter-"]').forEach((drawerContainer) => {
            const facetName = drawerContainer.querySelector('.ff-filter-label')?.textContent.trim();
            if (!facetName) return;
            if (availabilityLabels.includes(facetName)) {
              const optionCount = buildOptions(drawerContainer, this.querySelector('#subfilter-dropdown'), closeFfAvailabilityPanel, 'ff-cfb-availability-option');
              toggleSlot(availabilitySlot, optionCount > 0);
            } else if (sizeLabels.includes(facetName)) {
              const sizePanel = this.querySelector('#sort-dropdown');
              if (sizePanel) {
                const optionCount = buildOptions(drawerContainer, sizePanel, closeFfSizePanel, 'ff-cfb-size-option');
                toggleSlot(sizeSlot, optionCount > 0, sizeSeparator);
              }
            }
          });

          const anyFilterShown =
            (availabilitySlot && availabilitySlot.style.display !== 'none') ||
            (sizeSlot && sizeSlot.style.display !== 'none');
          this.style.display = anyFilterShown ? '' : 'none';
        }
      }

      customElements.define('ff-collection-filter-bar', FfCollectionFilterBar);
    })();
  }
  } catch(e) { console.error(e); }
})();

})();
